// Time utilities

export function renderTimeSeconds(s: number): string {
    if (isNaN(s) || !isFinite(s) || s < 0) {
        s = 0;
    }
    s = Math.floor(s);
    let hours = 0;
    let minutes = 0;
    if (s >= 3600) {
        hours = Math.floor(s / 3600);
        s = s % 3600;
    }
    if (s > 60) {
        minutes = Math.floor(s / 60);
        s = s % 60;
    }
    let r = "";

    if (s > 9) {
        r = "" + s + r;
    } else {
        r = "0" + s + r;
    }

    if (minutes > 9) {
        r = "" + minutes + ":" + r;
    } else {
        r = "0" + minutes + ":" + r;
    }

    if (hours > 0) {
        if (hours > 9) {
            r = "" + hours + ":" + r;
        } else {
            r = "0" + hours + ":" + r;
        }
    }

    return r;
}

export function renderDate(date: Date | string | number, $t: (t: string) => string) {
    if (!date) return "-";
    if (typeof date === "string" || typeof date === "number") {
        date = new Date(date);
    }

    const template = $t("[m] [d], [y]");
    const months = [
        $t("January"),
        $t("February"),
        $t("March"),
        $t("April"),
        $t("May"),
        $t("June"),
        $t("July"),
        $t("August"),
        $t("September"),
        $t("October"),
        $t("November"),
        $t("December"),
    ];

    const y = date.getFullYear();
    const d = date.getDate();

    let m = date.getMonth() + 1;

    m = m - 1;
    if (m < 0) {
        m = 0;
    } else if (m > months.length) {
        m = months.length - 1;
    }

    return ("" + template)
        .replace("[m]", months[m])
        .replace("[d]", d + "")
        .replace("[y]", y + "");
}

export function renderDateAndTime(date: Date | string | number, $t: (t: string) => string) {
    if (!date) return "-";
    if (typeof date === "string" || typeof date === "number") {
        date = new Date(date);
    }

    const template = $t("[m] [d], [y] [hh]:[mm]:[ss]");
    const months = [
        $t("January"),
        $t("February"),
        $t("March"),
        $t("April"),
        $t("May"),
        $t("June"),
        $t("July"),
        $t("August"),
        $t("September"),
        $t("October"),
        $t("November"),
        $t("December"),
    ];

    const y = date.getFullYear();
    const d = date.getDate();

    let m = date.getMonth() + 1;

    m = m - 1;
    if (m < 0) {
        m = 0;
    } else if (m > months.length) {
        m = months.length - 1;
    }

    let hh = "" + date.getHours();
    let mm = "" + date.getMinutes();
    let ss = "" + date.getSeconds();

    if (hh.length < 2) {
        hh = "0" + hh;
    }

    if (mm.length < 2) {
        mm = "0" + mm;
    }

    if (ss.length < 2) {
        ss = "0" + ss;
    }

    return ("" + template)
        .replace("[m]", months[m])
        .replace("[d]", d + "")
        .replace("[y]", y + "")
        .replace("[hh]", hh)
        .replace("[mm]", mm)
        .replace("[ss]", ss);
}

const MINUTE = 60;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

/**
 * Renders duration for humans
 * @param ms Milliseconds
 * @param $t The translation function
 * @returns The duration as string
 */
export function renderDuration(ms: number, $t: (t: string) => string): string {
    let s = Math.floor(ms / 1000);

    if (s <= 0) {
        return "0 " + $t("seconds");
    }

    const parts: string[] = [];

    if (s >= DAY) {
        const days = Math.floor(s / DAY);
        s = s % DAY;

        parts.push(days + " " + (days === 1 ? $t("day") : $t("days")));
    }

    if (s >= HOUR) {
        const hours = Math.floor(s / HOUR);
        s = s % HOUR;

        parts.push(hours + " " + (hours === 1 ? $t("hour") : $t("hours")));
    }

    if (s >= MINUTE) {
        const minutes = Math.floor(s / MINUTE);
        s = s % MINUTE;

        parts.push(minutes + " " + (minutes === 1 ? $t("minute") : $t("minutes")));
    }

    if (s > 0) {
        parts.push(s + " " + (s === 1 ? $t("second") : $t("seconds")));
    }

    return parts.join(",");
}

/**
 * Packs duration into value and multiplier
 * @param ms Duration (milliseconds)
 * @returns Value and multiplier
 */
export function packDuration(ms: number): { val: number; mul: number } {
    const s = Math.floor(ms / 1000);

    if (s % DAY === 0) {
        return { val: Math.floor(s / DAY), mul: DAY * 1000 };
    }

    if (s % HOUR === 0) {
        return { val: Math.floor(s / HOUR), mul: HOUR * 1000 };
    }

    if (s % MINUTE === 0) {
        return { val: Math.floor(s / MINUTE), mul: MINUTE * 1000 };
    }

    return { val: s, mul: 1000 };
}
